<template>

    <b-tabs content-class="mt-3">
        <b-tab title="Bills" active>
            <bills :bills="bills"></bills>
        </b-tab>

        <b-tab title="Payments">
            <bill_payments_table :payments="billing_data.payments"></bill_payments_table>
        </b-tab>
    </b-tabs>

</template>

<script>
import Bill_payments_table from "./bill_payments_table";
import Bills from "./bills";
export default {

    name: "bill_payments",
    components: {Bills, Bill_payments_table},
    props: {
        user: {
            type: Object
        },
        billing_data : {
            type: Object
        },
        bills : {
            type :Array
        }
    },

    data() {
        return {
            is_load: false,

        }
    },

    mounted() {

    },
    methods : {


    },

    computed : {

    }

}
</script>

<style scoped>

</style>
